var map = {
	"./cn/mobile/payment/mobile_bg.png": "351b",
	"./cn/mobile/payment/pay_tag.png": "b10b",
	"./cn/mobile/payment/step3_jd.png": "04e8",
	"./cn/mobile/payment/step3_online.png": "ee8c",
	"./cn/mobile/payment/step3_pay.png": "fa40",
	"./cn/mobile/payment/step3_qq.png": "d020",
	"./cn/mobile/payment/step3_wechat.png": "dd30",
	"./cn/payment/step3_jd.png": "6a69",
	"./cn/payment/step3_online.png": "b7d0",
	"./cn/payment/step3_pay.png": "ee3d",
	"./cn/payment/step3_qq.png": "5fea",
	"./cn/payment/step3_wechat.png": "80dc",
	"./cn/rbcnsystem/system_1_1.png": "5387",
	"./cn/rbcnsystem/system_1_2.png": "8465",
	"./cn/rbcnsystem/system_2_1.png": "5784",
	"./cn/rbcnsystem/system_2_2.png": "f379",
	"./cn/rbcnsystem/system_2_3.png": "215a",
	"./cn/rbcnsystem/system_3_1.png": "bc90",
	"./cn/rbcnsystem/system_3_2.png": "40fd",
	"./cn/rbcnsystem/system_4_1.png": "80dc8",
	"./cn/rbcnsystem/system_4_2.png": "5c58",
	"./cn/rbcnsystem/system_4_3.png": "cd2b",
	"./cn/rbcnsystem/system_5_1.png": "1a31",
	"./cn/rbcnsystem/system_5_2.png": "7763",
	"./cn/rbcnsystem/system_5_3.png": "c265",
	"./cn/rbcnsystem/system_6_1.png": "63a9",
	"./cn/rbcnsystem/system_6_2.png": "8ea8",
	"./cn/rbcnsystem/system_6_3.png": "39a1",
	"./cn/rbcnsystem/system_7_1.png": "efbd",
	"./cn/rbcnsystem/system_7_2.png": "8df1",
	"./cn/rbcnsystem/system_7_3.png": "f8c0",
	"./cn/rbcnsystem/system_7_4.png": "5881",
	"./cn/rbcnsystem/system_8_1.png": "727f",
	"./cn/rbcnsystem/system_8_2.png": "6cc2",
	"./contact/map_dot.png": "2888",
	"./cover/cover-dec-pluse.png": "9430",
	"./cover/cover-dec-techline-left.png": "7305",
	"./cover/cover-dec-techline-right.png": "aafa",
	"./develop/keno_ball_all.png": "1a9b",
	"./develop/keno_ball_bottom.png": "5c7b",
	"./develop/keno_ball_top.png": "393f",
	"./develop/keno_snails.png": "a7fe",
	"./develop/logo_1.png": "0a61",
	"./develop/logo_10.png": "88d6",
	"./develop/logo_2.png": "94eb",
	"./develop/logo_3.png": "46c1",
	"./develop/logo_4.png": "a27d",
	"./develop/logo_5.png": "70d4",
	"./develop/logo_6.png": "795e",
	"./develop/logo_7.png": "c922",
	"./develop/logo_8.png": "fd71",
	"./develop/logo_9.png": "b089",
	"./develop/photoarrow.png": "9cb7",
	"./develop/slot_item_after.png": "f1bc",
	"./develop/slot_item_before.png": "1f9e",
	"./develop/slot_item_bg.png": "76af",
	"./develop/slot_monkey.png": "4acd",
	"./develop/slot_warrior.png": "e44a",
	"./en/mobile/payment/mobile_bg.png": "fadd",
	"./en/mobile/payment/pay_tag.png": "07e6",
	"./en/mobile/payment/step3_jd.png": "4632",
	"./en/mobile/payment/step3_online.png": "6512",
	"./en/mobile/payment/step3_pay.png": "2dd1",
	"./en/mobile/payment/step3_qq.png": "a097",
	"./en/mobile/payment/step3_wechat.png": "0115",
	"./en/payment/step3_jd.png": "f570",
	"./en/payment/step3_online.png": "ae55",
	"./en/payment/step3_pay.png": "a7b3",
	"./en/payment/step3_qq.png": "03cf",
	"./en/payment/step3_wechat.png": "f495",
	"./en/rbcnsystem/system_1_1.png": "adf0",
	"./en/rbcnsystem/system_1_2.png": "0c79",
	"./en/rbcnsystem/system_2_1.png": "469a",
	"./en/rbcnsystem/system_2_2.png": "5afb",
	"./en/rbcnsystem/system_2_3.png": "9d1c",
	"./en/rbcnsystem/system_3_1.png": "de7c",
	"./en/rbcnsystem/system_3_2.png": "fae7",
	"./en/rbcnsystem/system_4_1.png": "14e9",
	"./en/rbcnsystem/system_4_2.png": "f6b1",
	"./en/rbcnsystem/system_4_3.png": "0225",
	"./en/rbcnsystem/system_5_1.png": "5639",
	"./en/rbcnsystem/system_5_2.png": "097f",
	"./en/rbcnsystem/system_5_3.png": "42d2",
	"./en/rbcnsystem/system_6_1.png": "be2d",
	"./en/rbcnsystem/system_6_2.png": "86a8",
	"./en/rbcnsystem/system_6_3.png": "249d",
	"./en/rbcnsystem/system_7_1.png": "4b25",
	"./en/rbcnsystem/system_7_2.png": "f25f",
	"./en/rbcnsystem/system_7_3.png": "4df5",
	"./en/rbcnsystem/system_7_4.png": "85df",
	"./en/rbcnsystem/system_8_1.png": "e31c",
	"./en/rbcnsystem/system_8_2.png": "e104",
	"./footer_188.png": "ec06",
	"./footer_ab.png": "55c6",
	"./footer_ag.png": "120a",
	"./footer_bb.png": "39c8",
	"./footer_bg.png": "0baa",
	"./footer_cmd.png": "7af8",
	"./footer_cq9.png": "bdcd",
	"./footer_ea.png": "16f2",
	"./footer_gd.png": "b286",
	"./footer_gg.png": "637f",
	"./footer_jdb.png": "7cea",
	"./footer_mg.png": "15b1",
	"./footer_n2.png": "105b",
	"./footer_os.png": "27b1",
	"./footer_ow.png": "4961",
	"./footer_pt.png": "8d31",
	"./footer_sg.png": "dc5a",
	"./footer_sunbet.png": "77d8",
	"./footer_tgp.png": "8bbc",
	"./g2e2017/highlight_1.png": "3d23",
	"./g2e2017/highlight_2.png": "f7d4",
	"./g2e2017/highlight_3.png": "0846",
	"./g2e2017/icon-highlight.png": "415c",
	"./g2e2017/icon-photo.png": "b8d1",
	"./g2e2017/icon-video.png": "4fb4",
	"./g2e2017/photo_info_bg.png": "a538",
	"./g2e2017/photoarrow.png": "3a76",
	"./g2e2017/photoshadow.png": "4e9b",
	"./g2e2017/pro_img.png": "a057",
	"./g2e2017/section_bg.png": "f6e7",
	"./g2e2017/section_kanban.png": "0978",
	"./g2e2017/section_logo1.png": "a43d",
	"./g2e2017/section_logo2.png": "c17e",
	"./g2e2018/slider_arrow.png": "c34d",
	"./g2e2018/video_bg.png": "1a57",
	"./gamelobby/min_1.png": "5bf2",
	"./gamelobby/min_10.png": "5212",
	"./gamelobby/min_11.png": "5c54",
	"./gamelobby/min_2.png": "4ab2",
	"./gamelobby/min_3.png": "6118",
	"./gamelobby/min_4.png": "1593",
	"./gamelobby/min_5.png": "ce24",
	"./gamelobby/min_6.png": "3009",
	"./gamelobby/min_7.png": "e53c",
	"./gamelobby/min_8.png": "37de",
	"./gamelobby/min_9.png": "72c4",
	"./hk/mobile/payment/mobile_bg.png": "efa6",
	"./hk/mobile/payment/pay_tag.png": "81bd",
	"./hk/mobile/payment/step3_jd.png": "a534",
	"./hk/mobile/payment/step3_online.png": "040c",
	"./hk/mobile/payment/step3_pay.png": "6b84",
	"./hk/mobile/payment/step3_qq.png": "625a",
	"./hk/mobile/payment/step3_wechat.png": "55ff",
	"./hk/payment/step3_jd.png": "54bf",
	"./hk/payment/step3_online.png": "d54c",
	"./hk/payment/step3_pay.png": "1d78",
	"./hk/payment/step3_qq.png": "18d1",
	"./hk/payment/step3_wechat.png": "df98",
	"./hk/rbcnsystem/system_1_1.png": "7e42",
	"./hk/rbcnsystem/system_1_2.png": "80ec",
	"./hk/rbcnsystem/system_2_1.png": "a221",
	"./hk/rbcnsystem/system_2_2.png": "ea5b",
	"./hk/rbcnsystem/system_2_3.png": "17c8",
	"./hk/rbcnsystem/system_3_1.png": "d79f",
	"./hk/rbcnsystem/system_3_2.png": "fac9",
	"./hk/rbcnsystem/system_4_1.png": "a123",
	"./hk/rbcnsystem/system_4_2.png": "542f",
	"./hk/rbcnsystem/system_4_3.png": "5f73",
	"./hk/rbcnsystem/system_5_1.png": "5295",
	"./hk/rbcnsystem/system_5_2.png": "7e1d",
	"./hk/rbcnsystem/system_5_3.png": "bae9",
	"./hk/rbcnsystem/system_6_1.png": "73ce",
	"./hk/rbcnsystem/system_6_2.png": "8b3d",
	"./hk/rbcnsystem/system_6_3.png": "9967",
	"./hk/rbcnsystem/system_7_1.png": "3e28",
	"./hk/rbcnsystem/system_7_2.png": "1164",
	"./hk/rbcnsystem/system_7_3.png": "44d9",
	"./hk/rbcnsystem/system_7_4.png": "01b0",
	"./hk/rbcnsystem/system_8_1.png": "a63e",
	"./hk/rbcnsystem/system_8_2.png": "82fb",
	"./home_introduction_1.png": "282f",
	"./home_introduction_2.png": "f0f1",
	"./home_introduction_3.png": "d0da",
	"./home_introduction_4.png": "8ff6",
	"./jp/mobile/payment/mobile_bg.png": "5511",
	"./jp/mobile/payment/pay_tag.png": "da92",
	"./jp/mobile/payment/step3_jd.png": "a50b",
	"./jp/mobile/payment/step3_online.png": "4b26",
	"./jp/mobile/payment/step3_pay.png": "dc3d",
	"./jp/mobile/payment/step3_qq.png": "9eed",
	"./jp/mobile/payment/step3_wechat.png": "14c0",
	"./jp/payment/step3_jd.png": "a524",
	"./jp/payment/step3_online.png": "8cdb",
	"./jp/payment/step3_pay.png": "43dd",
	"./jp/payment/step3_qq.png": "16c9",
	"./jp/payment/step3_wechat.png": "ad93",
	"./jp/rbcnsystem/system_1_1.png": "17ae",
	"./jp/rbcnsystem/system_1_2.png": "a560",
	"./jp/rbcnsystem/system_2_1.png": "8ed2",
	"./jp/rbcnsystem/system_2_2.png": "61c8",
	"./jp/rbcnsystem/system_2_3.png": "8edb",
	"./jp/rbcnsystem/system_3_1.png": "e1b1",
	"./jp/rbcnsystem/system_3_2.png": "9a60",
	"./jp/rbcnsystem/system_4_1.png": "871e",
	"./jp/rbcnsystem/system_4_2.png": "4c5a",
	"./jp/rbcnsystem/system_4_3.png": "deb8",
	"./jp/rbcnsystem/system_5_1.png": "8e61",
	"./jp/rbcnsystem/system_5_2.png": "7fad",
	"./jp/rbcnsystem/system_5_3.png": "a4cb",
	"./jp/rbcnsystem/system_6_1.png": "556f",
	"./jp/rbcnsystem/system_6_2.png": "16e0",
	"./jp/rbcnsystem/system_6_3.png": "b84c",
	"./jp/rbcnsystem/system_7_1.png": "b01b",
	"./jp/rbcnsystem/system_7_2.png": "330e",
	"./jp/rbcnsystem/system_7_3.png": "550d",
	"./jp/rbcnsystem/system_7_4.png": "464c",
	"./jp/rbcnsystem/system_8_1.png": "2434",
	"./jp/rbcnsystem/system_8_2.png": "fe5c",
	"./kr/mobile/payment/mobile_bg.png": "88a4",
	"./kr/mobile/payment/pay_tag.png": "67b6",
	"./kr/mobile/payment/step3_jd.png": "df0e",
	"./kr/mobile/payment/step3_online.png": "95bc",
	"./kr/mobile/payment/step3_pay.png": "8e45",
	"./kr/mobile/payment/step3_qq.png": "1bb5",
	"./kr/mobile/payment/step3_wechat.png": "c9aa",
	"./kr/payment/step3_jd.png": "092f",
	"./kr/payment/step3_online.png": "b791",
	"./kr/payment/step3_pay.png": "2df3",
	"./kr/payment/step3_qq.png": "19c4",
	"./kr/payment/step3_wechat.png": "74b7",
	"./kr/rbcnsystem/system_1_1.png": "5595",
	"./kr/rbcnsystem/system_1_2.png": "bff2",
	"./kr/rbcnsystem/system_2_1.png": "6103",
	"./kr/rbcnsystem/system_2_2.png": "5017",
	"./kr/rbcnsystem/system_2_3.png": "c13e",
	"./kr/rbcnsystem/system_3_1.png": "d6e8",
	"./kr/rbcnsystem/system_3_2.png": "1eb6",
	"./kr/rbcnsystem/system_4_1.png": "aaac",
	"./kr/rbcnsystem/system_4_2.png": "2ece",
	"./kr/rbcnsystem/system_4_3.png": "61c0",
	"./kr/rbcnsystem/system_5_1.png": "756f",
	"./kr/rbcnsystem/system_5_2.png": "cbd3",
	"./kr/rbcnsystem/system_5_3.png": "76bb",
	"./kr/rbcnsystem/system_6_1.png": "68ec",
	"./kr/rbcnsystem/system_6_2.png": "2306",
	"./kr/rbcnsystem/system_6_3.png": "93ff",
	"./kr/rbcnsystem/system_7_1.png": "3879",
	"./kr/rbcnsystem/system_7_2.png": "3c14",
	"./kr/rbcnsystem/system_7_3.png": "50a2",
	"./kr/rbcnsystem/system_7_4.png": "f3c9",
	"./kr/rbcnsystem/system_8_1.png": "c866",
	"./kr/rbcnsystem/system_8_2.png": "8773",
	"./logo.png": "9d64",
	"./mobile/g2e2017/highlight_1.png": "a622",
	"./mobile/g2e2017/highlight_2.png": "8480",
	"./mobile/g2e2017/highlight_3.png": "5a9c",
	"./mobile/g2e2017/icon-highlight.png": "6f18",
	"./mobile/g2e2017/icon-photo.png": "2a3b",
	"./mobile/g2e2017/icon-video.png": "e7a5",
	"./mobile/g2e2017/pro_img.png": "1e0e",
	"./mobile/g2e2017/section_kanban.png": "e51f",
	"./mobile/logo.png": "1721",
	"./mobile/rbcn/cell_shadow.png": "137a",
	"./mobile/rbcn/logo_ab.png": "829a",
	"./mobile/rbcn/logo_ag.png": "e254",
	"./mobile/rbcn/logo_bb.png": "c5b3",
	"./mobile/rbcn/logo_cmd.png": "c4a1",
	"./mobile/rbcn/logo_ea.png": "a458",
	"./mobile/rbcn/logo_fb.png": "09b0",
	"./mobile/rbcn/logo_gd.png": "28be",
	"./mobile/rbcn/logo_gg.png": "7007",
	"./mobile/rbcn/logo_gg2.png": "386e",
	"./mobile/rbcn/logo_jbb.png": "13b8",
	"./mobile/rbcn/logo_jdb.png": "89a9",
	"./mobile/rbcn/logo_mg.png": "1172",
	"./mobile/rbcn/logo_os.png": "4557",
	"./mobile/rbcn/logo_ow.png": "2e27",
	"./mobile/rbcn/logo_pt.png": "897c",
	"./mobile/rbcn/logo_sb.png": "347c",
	"./mobile/rbcn/logo_sp.png": "a7df",
	"./mobile/rbcn/logo_tgp.png": "fdd4",
	"./mobile/rbcn/process_1.png": "1694",
	"./mobile/rbcn/process_2.png": "1fac",
	"./mobile/rbcn/process_3.png": "a092",
	"./mobile/rbcn/rbcn-proArrow.png": "dcdb",
	"./mobile/rbcn/rbcn_pro_1.png": "d080",
	"./mobile/rbcn/rbcn_pro_2.png": "ffa0",
	"./mobile/rbcn/rbcn_pro_3.png": "5f12",
	"./mobile/rbcn/rbcn_pro_4.png": "ea24",
	"./mobile/rbcn/row_shadow.png": "1ab3",
	"./mobile/rbcn/specificationarrow.png": "856f",
	"./mobile/rblt/rblt_pro_2.png": "7e66",
	"./page2019/deco.png": "83c9",
	"./page2019/mb-deco.png": "b8a1",
	"./payment/circle - 複製.png": "ccae",
	"./payment/circle.png": "0c46",
	"./payment/circle_1.png": "aae0",
	"./payment/circle_2.png": "47d0",
	"./payment/circle_3.png": "d348",
	"./payment/circle_4.png": "bd88",
	"./payment/circle_5.png": "f75d",
	"./payment/circle_border.png": "1276",
	"./payment/fail.png": "c1eb",
	"./payment/jd.png": "a226",
	"./payment/logo.png": "44da",
	"./payment/mobile/cs.png": "776a",
	"./payment/mobile/fail.png": "d0fb",
	"./payment/mobile/jd.png": "d035",
	"./payment/mobile/logo.png": "cc94",
	"./payment/mobile/mobile_bg.png": "b84e",
	"./payment/mobile/online.png": "5fc2",
	"./payment/mobile/pay.png": "5c3c",
	"./payment/mobile/pay_tag.png": "498b",
	"./payment/mobile/prev.png": "3c38",
	"./payment/mobile/qq.png": "6587",
	"./payment/mobile/step3_jd.png": "ab54",
	"./payment/mobile/step3_online.png": "510a",
	"./payment/mobile/step3_pay.png": "4005",
	"./payment/mobile/step3_qq.png": "efa7",
	"./payment/mobile/step3_wechat.png": "2611",
	"./payment/mobile/success.png": "a8f8",
	"./payment/mobile/wechat.png": "ae6a",
	"./payment/online.png": "38d7",
	"./payment/pay.png": "171b",
	"./payment/pay_step1_left.png": "6a37",
	"./payment/pay_step1_left_hover.png": "8453",
	"./payment/pay_step1_right.png": "54d4",
	"./payment/pay_step1_right_hover.png": "59b1",
	"./payment/payment_1.png": "e75a",
	"./payment/payment_10.png": "0178",
	"./payment/payment_2.png": "8a69",
	"./payment/payment_3.png": "2c39",
	"./payment/payment_4.png": "648c",
	"./payment/payment_5.png": "0784",
	"./payment/payment_6.png": "e75d",
	"./payment/payment_7.png": "2bf5",
	"./payment/payment_8.png": "aece",
	"./payment/payment_9.png": "731c",
	"./payment/qq.png": "fdab",
	"./payment/step.png": "8647",
	"./payment/step3_jd.png": "ee78",
	"./payment/step3_online.png": "8694",
	"./payment/step3_pay.png": "7131",
	"./payment/step3_qq.png": "c554",
	"./payment/step3_wechat.png": "9335",
	"./payment/step_a.png": "e889",
	"./payment/step_e.png": "ca22",
	"./payment/success.png": "13cd",
	"./payment/wechat.png": "5a62",
	"./platform/bank/pay_bank_1.png": "1fc1",
	"./platform/bank/pay_bank_10.png": "6d08",
	"./platform/bank/pay_bank_11.png": "680e",
	"./platform/bank/pay_bank_12.png": "9daf",
	"./platform/bank/pay_bank_13.png": "37eb",
	"./platform/bank/pay_bank_14.png": "2606",
	"./platform/bank/pay_bank_15.png": "882c3",
	"./platform/bank/pay_bank_16.png": "8451",
	"./platform/bank/pay_bank_17.png": "55fd",
	"./platform/bank/pay_bank_18.png": "d315",
	"./platform/bank/pay_bank_19.png": "657e",
	"./platform/bank/pay_bank_2.png": "a3ce",
	"./platform/bank/pay_bank_20.png": "1d41",
	"./platform/bank/pay_bank_21.png": "cac7",
	"./platform/bank/pay_bank_22.png": "2f4d",
	"./platform/bank/pay_bank_3.png": "4457",
	"./platform/bank/pay_bank_4.png": "f79d",
	"./platform/bank/pay_bank_5.png": "dbaf",
	"./platform/bank/pay_bank_6.png": "60e8",
	"./platform/bank/pay_bank_7.png": "eb67",
	"./platform/bank/pay_bank_8.png": "78be",
	"./platform/bank/pay_bank_9.png": "f947",
	"./platform/logo/logo_188bet.png": "28a9",
	"./platform/logo/logo_ab.png": "209f",
	"./platform/logo/logo_ae.png": "d977",
	"./platform/logo/logo_ag.png": "e111",
	"./platform/logo/logo_ap.png": "38b4",
	"./platform/logo/logo_bb.png": "c94c",
	"./platform/logo/logo_bg.png": "7fa1",
	"./platform/logo/logo_cmd.png": "a70f",
	"./platform/logo/logo_cq9.png": "7e05",
	"./platform/logo/logo_ea.png": "c2d8",
	"./platform/logo/logo_evo.png": "c0ed",
	"./platform/logo/logo_ezu.png": "05a0",
	"./platform/logo/logo_fa.png": "097fb",
	"./platform/logo/logo_fg.png": "78cd",
	"./platform/logo/logo_gd.png": "fb2c",
	"./platform/logo/logo_gg.png": "cbbd",
	"./platform/logo/logo_gps.png": "9175",
	"./platform/logo/logo_gr.png": "6bad",
	"./platform/logo/logo_ha.png": "c9dc",
	"./platform/logo/logo_hc.png": "aa9a",
	"./platform/logo/logo_im.png": "4f44",
	"./platform/logo/logo_jdb.png": "fa9f",
	"./platform/logo/logo_ka.png": "814a",
	"./platform/logo/logo_ki.png": "2010",
	"./platform/logo/logo_ky.png": "c621",
	"./platform/logo/logo_leg.png": "65c4",
	"./platform/logo/logo_mg.png": "a9c7",
	"./platform/logo/logo_mw.png": "242d",
	"./platform/logo/logo_n2.png": "33ad",
	"./platform/logo/logo_ob.png": "4742",
	"./platform/logo/logo_og.png": "8578",
	"./platform/logo/logo_ow.png": "c154",
	"./platform/logo/logo_pg.png": "f7eb",
	"./platform/logo/logo_pt.png": "672c",
	"./platform/logo/logo_r88.png": "8881",
	"./platform/logo/logo_rbt.png": "69bc",
	"./platform/logo/logo_ron.png": "2a59",
	"./platform/logo/logo_rsg.png": "1b5c",
	"./platform/logo/logo_rsp.png": "8946",
	"./platform/logo/logo_sg.png": "2fe6",
	"./platform/logo/logo_sip.png": "bf7d",
	"./platform/logo/logo_sunbet.png": "dcfa",
	"./platform/logo/logo_tc.png": "6eb5",
	"./platform/logo/logo_tfg.png": "7aa8",
	"./platform/logo/logo_tgp.png": "f74e",
	"./platform/logo/logo_tp.png": "6e3f",
	"./platform/logo/logo_va.png": "a873",
	"./platform/logo/logo_vsl.png": "4f83",
	"./platform/logo/logo_wg.png": "d174",
	"./platform/logo/logo_wm.png": "f080",
	"./platform/logo/logo_xg.png": "778f",
	"./platform/logo/logo_yl.png": "e94a",
	"./platform/pay/pay_alipay.png": "9440",
	"./platform/pay/pay_debit.png": "c169",
	"./platform/pay/pay_jdpay.png": "16c4",
	"./platform/pay/pay_qq.png": "4bd3",
	"./platform/pay/pay_tenpay.png": "4acf",
	"./platform/pay/pay_unionpay.png": "d2e2",
	"./platform/pay/pay_wechat.png": "cd49",
	"./platformlobby/01/banner.png": "2ae8",
	"./platformlobby/02/banner.png": "ee37",
	"./platformlobby/03/banner.png": "0bbb",
	"./platformlobby/04/banner.png": "996f",
	"./platformlobby/05/banner.png": "e157",
	"./platformlobby/06/banner.png": "29f3",
	"./platformlobby/07/banner.png": "3a93",
	"./platformlobby/08/banner.png": "6cea",
	"./platformlobby/09/banner.png": "f040",
	"./platformlobby/10/banner.png": "a4d4",
	"./platformlobby/11/banner.png": "8c14",
	"./platformlobby/12/banner.png": "15d5",
	"./platformlobby/13/banner.png": "7b94",
	"./platformlobby/14/banner.png": "58b9",
	"./platformlobby/demo_btn_ico.png": "4859",
	"./platformlobby/info_ico.png": "4d95",
	"./popup/fake-popup-MB-2-2.png": "29cd",
	"./popup/fake-popup-PC-2.png": "a5f7",
	"./rbcn/logo_ab.png": "9677",
	"./rbcn/logo_ae.png": "c3ad",
	"./rbcn/logo_ag.png": "20b9",
	"./rbcn/logo_ap.png": "027e",
	"./rbcn/logo_bb.png": "92f0",
	"./rbcn/logo_bg.png": "32af",
	"./rbcn/logo_cmd.png": "42d5",
	"./rbcn/logo_cq9.png": "df1a",
	"./rbcn/logo_ea.png": "9f54",
	"./rbcn/logo_evo.png": "8131",
	"./rbcn/logo_ez.png": "99d3",
	"./rbcn/logo_fa.png": "8330",
	"./rbcn/logo_fb.png": "6826",
	"./rbcn/logo_fg.png": "24bc",
	"./rbcn/logo_gd.png": "9049",
	"./rbcn/logo_gg.png": "1d1c",
	"./rbcn/logo_gp.png": "1121",
	"./rbcn/logo_gps.png": "e5e7",
	"./rbcn/logo_hc.png": "13f7",
	"./rbcn/logo_im.png": "97a5",
	"./rbcn/logo_jbb.png": "4947",
	"./rbcn/logo_jdb.png": "84be",
	"./rbcn/logo_mg.png": "5a8d",
	"./rbcn/logo_mw.png": "0d6f",
	"./rbcn/logo_n2.png": "6188",
	"./rbcn/logo_nbb.png": "3701",
	"./rbcn/logo_ob.png": "c6aa",
	"./rbcn/logo_og.png": "94d7",
	"./rbcn/logo_ow.png": "7291",
	"./rbcn/logo_pg.png": "87a8",
	"./rbcn/logo_pt.png": "2c5d",
	"./rbcn/logo_r88.png": "7f1c",
	"./rbcn/logo_ron.png": "b5cf",
	"./rbcn/logo_rsg.png": "d60a",
	"./rbcn/logo_rsp.png": "92ff",
	"./rbcn/logo_sb.png": "d9f2",
	"./rbcn/logo_sbs.png": "08a6",
	"./rbcn/logo_sp.png": "78ae",
	"./rbcn/logo_tc.png": "2466",
	"./rbcn/logo_tfg.png": "e83d",
	"./rbcn/logo_tp.png": "d13f",
	"./rbcn/logo_va.png": "3a66",
	"./rbcn/logo_vsl.png": "601a",
	"./rbcn/logo_wg.png": "882c",
	"./rbcn/logo_wm.png": "52ca",
	"./rbcn/logo_xg.png": "baaf",
	"./rbcn/logo_yl.png": "fc6d",
	"./rbcn/process_1.png": "1ac3",
	"./rbcn/process_1_h.png": "8b93",
	"./rbcn/process_2.png": "0246",
	"./rbcn/process_2_h.png": "12db",
	"./rbcn/process_3.png": "0582",
	"./rbcn/process_3_h.png": "98bf",
	"./rbcn/rbcn_contact_left.png": "6c02",
	"./rbcn/rbcn_contact_right.png": "9892",
	"./rbcn/rbcn_pro_1.png": "a441",
	"./rbcn/rbcn_pro_2.png": "a1a5",
	"./rbcn/rbcn_pro_3.png": "2e96",
	"./rbcn/rbcn_pro_4.png": "b2d4",
	"./rbcn/sprb_step.png": "81ac",
	"./rbcnsystem/arrow_next.png": "8bc4",
	"./rbcnsystem/arrow_prev.png": "e20d",
	"./rblt/keno_logo_1.png": "7824",
	"./rblt/keno_logo_10.png": "3f9f",
	"./rblt/keno_logo_11.png": "d7cc",
	"./rblt/keno_logo_12.png": "4b7d",
	"./rblt/keno_logo_13.png": "74fb",
	"./rblt/keno_logo_14.png": "5adf",
	"./rblt/keno_logo_15.png": "47d6",
	"./rblt/keno_logo_16.png": "7edf",
	"./rblt/keno_logo_17.png": "45f9",
	"./rblt/keno_logo_18.png": "63d2",
	"./rblt/keno_logo_19.png": "8faa",
	"./rblt/keno_logo_2.png": "eb22",
	"./rblt/keno_logo_20.png": "e3f7",
	"./rblt/keno_logo_21.png": "eef7",
	"./rblt/keno_logo_22.png": "794d",
	"./rblt/keno_logo_23.png": "d5e8",
	"./rblt/keno_logo_3.png": "cf95",
	"./rblt/keno_logo_4.png": "dbad",
	"./rblt/keno_logo_5.png": "1670",
	"./rblt/keno_logo_6.png": "3e87",
	"./rblt/keno_logo_7.png": "4656",
	"./rblt/keno_logo_8.png": "e46e",
	"./rblt/keno_logo_9.png": "ca33",
	"./rblt/rblt_pro_2.png": "8ee8",
	"./statement/caveat.png": "8e27",
	"./statement/close.png": "f891",
	"./statement/img1.png": "6872",
	"./statement/img2.png": "4a65",
	"./statement/logo.png": "cf0c",
	"./support/support_equi_1.png": "7603",
	"./support/support_equi_2.png": "26b0",
	"./support/support_equi_3.png": "e3d8",
	"./support/support_equi_4.png": "58b2",
	"./support/support_moni_1.png": "8878",
	"./support/support_moni_2.png": "8caf",
	"./support/support_moni_3.png": "6511",
	"./support/support_prot_1.png": "1a93",
	"./support/support_prot_2.png": "781a",
	"./support/support_prot_3.png": "a1a4",
	"./support/support_prot_4.png": "91da",
	"./support/support_prot_5.png": "3697",
	"./th/mobile/payment/mobile_bg.png": "3191",
	"./th/mobile/payment/pay_tag.png": "b9a1",
	"./th/mobile/payment/step3_jd.png": "1859",
	"./th/mobile/payment/step3_online.png": "8c12",
	"./th/mobile/payment/step3_pay.png": "4094",
	"./th/mobile/payment/step3_qq.png": "14d3",
	"./th/mobile/payment/step3_wechat.png": "eb71",
	"./th/payment/step3_jd.png": "b35a",
	"./th/payment/step3_online.png": "fc6b",
	"./th/payment/step3_pay.png": "6028",
	"./th/payment/step3_qq.png": "004b",
	"./th/payment/step3_wechat.png": "863d",
	"./th/rbcnsystem/system_1_1.png": "cb30",
	"./th/rbcnsystem/system_1_2.png": "4815",
	"./th/rbcnsystem/system_2_1.png": "6203",
	"./th/rbcnsystem/system_2_2.png": "0ec7",
	"./th/rbcnsystem/system_2_3.png": "718a",
	"./th/rbcnsystem/system_3_1.png": "a010",
	"./th/rbcnsystem/system_3_2.png": "ff82",
	"./th/rbcnsystem/system_4_1.png": "e7df",
	"./th/rbcnsystem/system_4_2.png": "a1ac",
	"./th/rbcnsystem/system_4_3.png": "8575",
	"./th/rbcnsystem/system_5_1.png": "acee",
	"./th/rbcnsystem/system_5_2.png": "f205",
	"./th/rbcnsystem/system_5_3.png": "fd3f",
	"./th/rbcnsystem/system_6_1.png": "9498",
	"./th/rbcnsystem/system_6_2.png": "520c",
	"./th/rbcnsystem/system_6_3.png": "9495",
	"./th/rbcnsystem/system_7_1.png": "031b",
	"./th/rbcnsystem/system_7_2.png": "8a6d",
	"./th/rbcnsystem/system_7_3.png": "ba51",
	"./th/rbcnsystem/system_7_4.png": "a0ff",
	"./th/rbcnsystem/system_8_1.png": "359c",
	"./th/rbcnsystem/system_8_2.png": "3f1e",
	"./vn/mobile/payment/mobile_bg.png": "e38b",
	"./vn/mobile/payment/pay_tag.png": "fc23",
	"./vn/mobile/payment/step3_jd.png": "13ea",
	"./vn/mobile/payment/step3_online.png": "e64b",
	"./vn/mobile/payment/step3_pay.png": "338a",
	"./vn/mobile/payment/step3_qq.png": "49cf",
	"./vn/mobile/payment/step3_wechat.png": "241b",
	"./vn/payment/step3_jd.png": "2f41",
	"./vn/payment/step3_online.png": "112c",
	"./vn/payment/step3_pay.png": "b6fa",
	"./vn/payment/step3_qq.png": "4749",
	"./vn/payment/step3_wechat.png": "eee7",
	"./vn/rbcnsystem/system_1_1.png": "993c",
	"./vn/rbcnsystem/system_1_2.png": "6053",
	"./vn/rbcnsystem/system_2_1.png": "5c42",
	"./vn/rbcnsystem/system_2_2.png": "2a1a",
	"./vn/rbcnsystem/system_2_3.png": "b5ed",
	"./vn/rbcnsystem/system_3_1.png": "9607",
	"./vn/rbcnsystem/system_3_2.png": "2426",
	"./vn/rbcnsystem/system_4_1.png": "f932",
	"./vn/rbcnsystem/system_4_2.png": "2d74",
	"./vn/rbcnsystem/system_4_3.png": "7a82",
	"./vn/rbcnsystem/system_5_1.png": "afa8",
	"./vn/rbcnsystem/system_5_2.png": "c5cd",
	"./vn/rbcnsystem/system_5_3.png": "36f4",
	"./vn/rbcnsystem/system_6_1.png": "0a66",
	"./vn/rbcnsystem/system_6_2.png": "8a97",
	"./vn/rbcnsystem/system_6_3.png": "e5d9",
	"./vn/rbcnsystem/system_7_1.png": "8b35",
	"./vn/rbcnsystem/system_7_2.png": "a101",
	"./vn/rbcnsystem/system_7_3.png": "4d44",
	"./vn/rbcnsystem/system_7_4.png": "2f55",
	"./vn/rbcnsystem/system_8_1.png": "6b8b",
	"./vn/rbcnsystem/system_8_2.png": "213b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";